import {
  Box,
  Button,
  Container,
  Grid,
  Typography,
  styled,
  useTheme,
} from "@mui/material";

import { SettingIcon } from "assets/Icon";
import { useNavigate } from "react-router-dom";

export default function P2P() {
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <Container>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <UnderConstruction>
            <Icon>
              <SettingIcon color={theme.palette.secondary.main} />
            </Icon>

            <Typography color="text.main">
              Awesome, more features coming soon ...
            </Typography>

            <Button
              variant="text"
              color="secondary"
              onClick={() => {
                navigate(-1);
              }}
            >
              Back
            </Button>
          </UnderConstruction>
        </Grid>
      </Grid>
    </Container>
  );
}

const UnderConstruction = styled(Box)(({ theme }) => ({
  minHeight: `calc(100vh - 120px)`,
  padding: "20px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
}));

const Icon = styled(Box)(() => ({
  svg: {
    animation: "rotate 3s infinite ease-out",
    width: "10em !important",
    height: "10em !important",
  },

  "@keyframes rotate": {
    "0%": {
      transform: "rotate(0deg)",
    },
    "100%": {
      transform: "rotate(359deg)",
    },
  },
}));
